module.exports = __webpack_public_path__ + "img/img44.d55813db.png";